import { HTTP_DESKRH } from '../http';

export default {

  getSignWorkflows(searchParams) {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_LISTING_ROUTE}`, searchParams)
      .then(data => data.data.data);
  },

  getSignWorkflow(id) {
    return HTTP_DESKRH.get(`${process.env.API_SIGNWORKFLOW_LISTING_ROUTE}/${id}`)
      .then(data => data.data.data);
  },

  getSignWorkflowsByUser(params) {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_PENDING_ROUTE}/${params.id}`, params.parameters)
      .then(data => data.data.data);
  },

  getTemplates(searchParams) {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_TEMPLATE_LISTING_ROUTE}`, searchParams)
      .then(data => data.data.data.signWorkflowTemplates);
  },

  getTemplate(id) {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_TEMPLATE_LISTING_ROUTE}/${id}`)
      .then(data => data);
  },

  newSignWorkflowOld(signWorkflow) {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_ROUTE}`, signWorkflow)
      .then(data => data);
  },

  newSignWorkflow(signWorkflow, files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append(file.id, file.file, `${file.docTypeCode}:${file.description}`);
    });

    formData.append('json', JSON.stringify(signWorkflow));

    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_ROUTE}/upload`, formData, config);
  },

  checkSignatureCode(params) {
    const checkParams = {
      codeSignature: params.signatureCode,
    };
    const config = {
      header: { 'content-type': 'charset=UTF-8' },
    };
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_ROUTE}/sign/${params.workflowId}`, checkParams, config);
  },

  sendSignatureCodeReminder(params) {
    const reminderParams = {
      mode: params.mode,
      phone: params.phone,
      email: params.email,
    };
    const config = {
      header: { 'content-type': 'charset=UTF-8' },
    };
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_ROUTE}/recover-signature-code/${params.workflowId}`, reminderParams, config);
  },

  updateSignWorkflow(signWorkflow) {
    return HTTP_DESKRH.put(`${process.env.API_SIGNWORKFLOW_LISTING_ROUTE}/${signWorkflow.id}`, signWorkflow)
      .then(data => data);
  },

  deleteSignWorkflow(id) {
    return HTTP_DESKRH.delete(`${process.env.API_SIGNWORKFLOW_ROUTE}/${id}`)
      .then(data => data);
  },

  newTemplate() {
    return HTTP_DESKRH.post(`${process.env.API_SIGNWORKFLOW_TEMPLATE_ROUTE}`)
      .then(data => data);
  },

  updateTemplate(id) {
    return HTTP_DESKRH.put(`${process.env.API_SIGNWORKFLOW_TEMPLATE_ROUTE}/${id}`)
      .then(data => data);
  },

  deleteTemplate(id) {
    return HTTP_DESKRH.delete(`${process.env.API_SIGNWORKFLOW_TEMPLATE_ROUTE}/${id}`)
      .then(data => data);
  },
};



// WEBPACK FOOTER //
// ./src/api/signworkflow.js